import I18n from "i18n-js";

/* 
 * Usage: Server side translations rendered as a json on the client side, then imported into React components
 * window.gb_data.I18n 
 *  - loaded by hotel_integration.js.erb, available for BEI 2.0 related React components
 * window.I18n 
 *  - loaded for use in our platform pages (landing page, etc)
 */
const { defaultLocale, locale, translations } = window.I18n ? window.I18n : window.gb_data.I18n;
// const { defaultLocale, locale, translations, in_context_editor } = window.I18n;

I18n.defaultLocale = defaultLocale;
I18n.locale = locale;
I18n.translations = translations;

/* 
 * added function to support live editing translations in development.
 * adds [[__phrase_ .. to all the translations and letting script understand areas where translations were applied
 */
// I18n.pt = function(key, options = {}) {
//   return in_context_editor ? "[[__phrase_" + key + "__]]" : I18n.t(key, options)
// };
          
export default I18n;
